/*Form component in the CrewInfoEdit Form
  component to add/edit the Location Department crew info */
import React, { useRef, useState } from "react";
import { useRedirect } from '../../../../hooks/Redirect';
import Form from "react-bootstrap/Form";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Alert } from "react-bootstrap";
import { Select as ManSelect } from "@mantine/core";
import { formatCrewOptionLabel } from "../crewSelectHelpers";
import styles from "../../../../styles/Callsheets.module.css";

const CrewLocations = ({
  handleChange,
  postData,
  setShow,
  crewOptions = [],
  selectedCrewIds = {},
  handleCrewSelection,
  crewSearchQuery = "",
  setCrewSearchQuery,
  crewSearchLoading = false,
}) => {
  useRedirect();
  // eslint-disable-next-line
  const [errors, setErrors] = useState({});
  const [isCrewSearchOpen, setIsCrewSearchOpen] = useState(false);
  const ignoreNextSearchChangeRef = useRef(false);

  const {location_mngr_name, location_mngr_email, location_mngr_phone,
    location_ass_1_name, location_ass_1_email, location_ass_1_phone,
    location_ass_2_name, location_ass_2_email, location_ass_2_phone,
    location_ass_3_name, location_ass_3_email, location_ass_3_phone,
    location_ass_4_name, location_ass_4_email, location_ass_4_phone,
    location_security_name, location_security_email, location_security_phone,
  } = postData || {};

    const renderCrewSelect = (rolePrefix, label = "Crew Member") => (
    <Row className="mt-2">
      <Col xs={12} md={{ span: 8, offset: 2 }} className="d-flex justify-content-center p-0 p-lg-2">
        <Form.Group controlId={`${rolePrefix}_crew_select`} className={`${styles.Width} `}>
          <Form.Label className={`${styles.BoldScene}`}>{label}</Form.Label>
          <ManSelect
            data={[
              { label: "(Clear selection)", value: "" },
              ...crewOptions.map((user) => ({
                label: formatCrewOptionLabel(user) || "Unnamed Crew",
                value: String(user?.id),
              })),
            ]}
            classNames={{
              input: styles.Input,
            }}
            value={selectedCrewIds?.[rolePrefix] || null}
            onChange={(value) => {
              ignoreNextSearchChangeRef.current = true;
              if (handleCrewSelection) {
                handleCrewSelection(rolePrefix)(value);
              }
            }}
            placeholder="Search by call time name"
            searchable
            onSearchChange={(nextQuery) => {
              if (ignoreNextSearchChangeRef.current) {
                ignoreNextSearchChangeRef.current = false;
                return;
              }

              const selectedId = selectedCrewIds?.[rolePrefix];
              const selectedUser = crewOptions.find(
                (user) => String(user?.id) === String(selectedId)
              );
              const selectedLabel = selectedUser
                ? formatCrewOptionLabel(selectedUser)
                : "";
              if (
                selectedLabel &&
                String(nextQuery || "").trim() === String(selectedLabel || "").trim()
              ) {
                return;
              }

              if (isCrewSearchOpen && setCrewSearchQuery) {
                setCrewSearchQuery(nextQuery);
              }
            }}
            onDropdownOpen={() => {
              setIsCrewSearchOpen(true);
              if (setCrewSearchQuery) {
                setCrewSearchQuery("");
              }
            }}
            onDropdownClose={() => {
              setIsCrewSearchOpen(false);
            }}
            filter={() => true}
            nothingFound={crewSearchLoading ? "Searching..." : "No crew found"}
          />
        </Form.Group>
      </Col>
    </Row>
  );
  // Callnames are static per position (do not derive from selected crew).

  return (
    <div className="pb-3 text-center">
      <div className={`mt-0 text-center ${styles.SubTitle }`}>
      <span className={`float-right pt-1 ${styles.Bold } ${styles.Close }`} onClick={() => setShow(false) } >Close</span> 
      <h5 className={`d-none d-md-block pl-5 mb-0 text-center py-1 ${styles.Bold }`} >
      LOCATIONS DEPARTMENT</h5>
      <h5 className={`d-block d-md-none pl-5 mb-0 text-center py-1 ${styles.Bold }`} >
      LOCATIONS</h5>
      </div>
      <div className={`px-2 px-md-5 mx-md-5 pt-3 ${styles.White }`}>
      {/* Location Manager */}
      <div>
      <p className={`mb-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Location Manager</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: locmngr</span> 
      </div>
      {renderCrewSelect("location_mngr")}
      <Row className="mt-2">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_mngr_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_mngr_name"
              value={location_mngr_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_mngr_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_mngr_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_mngr_phone"
              value={location_mngr_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_mngr_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_mngr_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_mngr_email"
              value={location_mngr_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_mngr_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Location Manager 2/Other - (using Location Assistant 1 keys for this) */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Location Manager 2/Other</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: locast1</span>
      </div>
      {renderCrewSelect("location_ass_1")}
      <Row className="mt-2">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_1_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_1_name"
              value={location_ass_1_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_1_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_1_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_1_phone"
              value={location_ass_1_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_1_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_1_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_1_email"
              value={location_ass_1_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_1_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Assistant Location Manager - (using "Location Assistant 2" keys for this) */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Assistant Location Manager</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: locast2</span>
      </div>
      {renderCrewSelect("location_ass_2")}
      <Row className="mt-2">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_2_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_2_name"
              value={location_ass_2_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_2_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_2_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_2_phone"
              value={location_ass_2_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_2_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_2_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_2_email"
              value={location_ass_2_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_2_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Location Assistant 1 - (using "Location Assistant 3" keys for this) */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Location Assistant 1</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: locast3</span> 
      </div>
      {renderCrewSelect("location_ass_3")}
      <Row className="mt-2">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_3_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_3_name"
              value={location_ass_3_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_3_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_3_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_3_phone"
              value={location_ass_3_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_3_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_3_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_3_email"
              value={location_ass_3_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_3_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Location Assistant 2 - (using "Location Assistant 4" keys for this) */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Location Assistant 2</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: locast4</span> 
      </div>
      {renderCrewSelect("location_ass_4")}
      <Row className="mt-2">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_4_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_4_name"
              value={location_ass_4_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_4_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_4_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_4_phone"
              value={location_ass_4_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_4_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_ass_4_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_ass_4_email"
              value={location_ass_4_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_ass_4_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      {/* Location Security/Other */}
      <div>
      <p className={`my-3 py-0 mx-md-4 ${styles.SubTitle }` } 
      style={{ textTransform: 'uppercase'}}>Location Security/Other</p> 
      <div>
      <span className={`py-1 px-3 px-md-5 ${styles.BoldTitleCall }`} >
        CALLNAME: locsecur</span>
      </div>
      {renderCrewSelect("location_security")}
      <Row className="mt-2">
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_security_name" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene} `} >Name</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_security_name"
              value={location_security_name}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_security_name?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={6} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_security_phone" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Phone</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_security_phone"
              value={location_security_phone}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_security_phone?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
          <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-lg-2">
          <Form.Group controlId="location_security_email" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Email</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="location_security_email"
              value={location_security_email}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.location_security_email?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
          </Col>
      </Row>
      </div>
      {/* break */}
      <Row>
      <Col xs={12}>
      <hr className={`mt-3 mb-3`}/>
      </Col>
      </Row>
      </div>
    </div>
  )
}

export default CrewLocations

